export default "__VITE_ASSET__qyNhJnL1__"